// MOD-CUSTOM: PDP USP surface rendering — fills subheadline, overview_bullets, and macro_bullets

(function () {
  'use strict';

  function initializeUspOnPage() {
    var productDataElement = document.getElementById('usp-pdp-product-data');
    var personaDataElement = document.getElementById('usp-persona-surface-data');
    if (!productDataElement || !personaDataElement) return;

    var productDataArray, personaDataArray;
    try {
      productDataArray = JSON.parse(productDataElement.textContent);
      personaDataArray = JSON.parse(personaDataElement.textContent);
    } catch (error) { return; }

    if (!productDataArray.length) return;

    window.UspEngine.renderUspOnPage(productDataArray[0].productId, productDataArray, personaDataArray);

    // Move overlays into the first slide of each media area so they slide with the image.
    // .swiper-slide has position:relative, so position:absolute is scoped to the slide.
    // Nav buttons live outside the slide in the .swiper context and paint above it naturally.
    var firstSlideSelectors = [
      '#productMediaDesktop [data-media-main] .swiper-slide:first-child',
      '#productMediaMobile [data-media-main] .swiper-slide:first-child'
    ];

    var calloutTemplate = document.querySelector('[data-usp-pdp-callout]');
    if (calloutTemplate) {
      firstSlideSelectors.forEach(function (selector, selectorIndex) {
        var firstSlide = document.querySelector(selector);
        if (!firstSlide) return;
        var calloutNode = selectorIndex === 0 ? calloutTemplate : calloutTemplate.cloneNode(true);
        firstSlide.appendChild(calloutNode);
        calloutNode.removeAttribute('aria-hidden');
      });
    }

    var badgesTemplate = document.querySelector('[data-usp-pdp-callout-badges]');
    if (badgesTemplate) {
      firstSlideSelectors.forEach(function (selector, selectorIndex) {
        var firstSlide = document.querySelector(selector);
        if (!firstSlide) return;
        var badgesNode = selectorIndex === 0 ? badgesTemplate : badgesTemplate.cloneNode(true);
        firstSlide.appendChild(badgesNode);
        badgesNode.removeAttribute('aria-hidden');
      });
    }
  }

  // Guard against either script loading first — if UspEngine is already defined run now,
  // otherwise wait for the engine's ready event.
  function tryInitialize() {
    if (window.UspEngine) {
      initializeUspOnPage();
    } else {
      document.addEventListener('usp-engine:ready', initializeUspOnPage, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInitialize);
  } else {
    tryInitialize();
  }
}());
